import { render, staticRenderFns } from "./log-group.vue?vue&type=template&id=6db05976&scoped=true"
import script from "./log-group.vue?vue&type=script&lang=js"
export * from "./log-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db05976",
  null
  
)

export default component.exports